<!--
  @component StorageScreen — "Storage" section (per-project): mounts StorageIO
             so the Drive-like file browser can reach the project's R2 bucket.
  tier:      screen (per-project, scope=one → /deployments/storage?p=:id)
-->
<script lang="ts">
  import StorageIO from "../../../../global/io/nodes/deployment/StorageIO.svelte";
  import StoragePanel from "./StoragePanel.svelte";
</script>

<StorageIO>
  {#snippet children()}
    <StoragePanel />
  {/snippet}
</StorageIO>
